import Adrienne from '../../pages/adrienne/Adrienne'

import PrefixEnum from '../prefixes'

export default Object.freeze([
    { path: PrefixEnum.ADRIENNE, component: Adrienne },
])
